var pickerMixin = {
    methods: {
        handleChoose: function (event) {
            event.stopPropagation();
            this.$emit("closePicker");
        },
    },
};
export default pickerMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/pickerMixin.ts
// module id = 6Ipl
// module chunks = 18